import _styled, { default as _styled2, default as _styled3, default as _styled4, default as _styled5, default as _styled6 } from "styled-components";
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import React from 'react';
import PropTypes from 'prop-types';
import { ENTITLEMENTS_PLATFORM_TYPES } from '@adsk/alloy-provider';
import { LogoAutodeskAccIcon, LogoAutodeskBim360Icon } from '@adsk/alloy-react-icon';
import { MenuItem } from '@adsk/alloy-react-menu';
import theme from '@adsk/alloy-react-theme';
import { MFAIcon } from './MFAIcon';
import getAnchorRel from '../helpers/getAnchorRel';
import getAnchorTarget from '../helpers/getAnchorTarget';
import getProjectUrl from '../helpers/getProjectUrl';
import { projectShape } from '../helpers/propTypes';
const ProjectListProjectItem = _ref => {
  let {
    item: project,
    currentProjectId,
    currentProductId,
    onClose,
    onProjectClick,
    handleAnalyticOnClick,
    containerRef
  } = _ref;
  const {
    id,
    platform
  } = project;
  const url = getProjectUrl(project, currentProductId);
  const highlighted = currentProjectId === id;
  const LogoComponent = platform === ENTITLEMENTS_PLATFORM_TYPES.ACC ? LogoAutodeskAccIcon : LogoAutodeskBim360Icon;
  return /*#__PURE__*/React.createElement(MenuItem, {
    "data-testid": "ProjectPicker__project-".concat(id),
    rel: getAnchorRel(url),
    highlighted: highlighted,
    showSelection: false,
    as: onProjectClick ? 'button' : 'a',
    href: url,
    target: getAnchorTarget(url),
    onClick: () => {
      onProjectClick === null || onProjectClick === void 0 ? void 0 : onProjectClick(project, url);
      handleAnalyticOnClick === null || handleAnalyticOnClick === void 0 ? void 0 : handleAnalyticOnClick(project);
      onClose === null || onClose === void 0 ? void 0 : onClose();
    },
    style: {
      height: 'auto',
      padding: '8px 16px',
      textAlign: 'initial'
    }
  }, /*#__PURE__*/React.createElement(_StyledDiv, {
    $_css: [{
      display: 'flex',
      flex: 1,
      alignItems: 'center'
    }]
  }, /*#__PURE__*/React.createElement(_StyledDiv2, {
    $_css2: [{
      width: '48px',
      height: '48px',
      marginRight: theme.spacing.medium
    }]
  }, /*#__PURE__*/React.createElement(_StyledImg, {
    src: project.imageUrl,
    "data-testid": "item-image",
    $_css3: [{
      width: '100%',
      height: '100%',
      objectFit: 'contain',
      borderRadius: 5
    }]
  })), /*#__PURE__*/React.createElement(_StyledDiv3, {
    $_css4: [{
      flex: 1,
      maxWidth: '216px'
    }]
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex',
      alignItems: 'center'
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      flexDirection: 'column',
      display: 'flex',
      overflow: 'hidden'
    }
  }, /*#__PURE__*/React.createElement(_StyledDiv4, {
    $_css5: [theme.typography.heading4, theme.typography.lineClamp, {
      color: highlighted ? theme.colors.white : theme.colors.charcoal900
    }]
  }, project.name), /*#__PURE__*/React.createElement(_StyledDiv5, {
    $_css6: [theme.typography.caption, theme.typography.ellipsis, {
      color: highlighted ? theme.colors.white : theme.colors.charcoal600
    }]
  }, project.accountName)), project.mfaBlocked && /*#__PURE__*/React.createElement(MFAIcon, {
    containerRef: containerRef
  }))), /*#__PURE__*/React.createElement(LogoComponent, {
    size: 16,
    style: {
      color: highlighted ? theme.colors.white : theme.colors.acsLogoBlue,
      marginLeft: theme.spacing.medium
    }
  })));
};
ProjectListProjectItem.displayName = 'ProjectListProjectItem';
ProjectListProjectItem.propTypes = {
  /** The project item to show */
  item: projectShape,
  /** current selected project id */
  currentProjectId: PropTypes.string,
  /** current product ID, to check if project has entitlements for or not */
  currentProductId: PropTypes.string,
  /** menu close handler */
  onClose: PropTypes.func,
  /** project click handler */
  onProjectClick: PropTypes.func
};
export default ProjectListProjectItem;
var _StyledDiv = _styled("div")(_templateObject || (_templateObject = _taggedTemplateLiteral(["", ""])), p => p.$_css);
var _StyledDiv2 = _styled2("div")(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["", ""])), p => p.$_css2);
var _StyledImg = _styled3("img")(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["", ""])), p => p.$_css3);
var _StyledDiv3 = _styled4("div")(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["", ""])), p => p.$_css4);
var _StyledDiv4 = _styled5("div")(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["", ""])), p => p.$_css5);
var _StyledDiv5 = _styled6("div").withConfig({
  displayName: "ProjectListProjectItem___StyledDiv5",
  componentId: "sc-1f1wj6r-0"
})(["", ""], p => p.$_css6);
//# sourceMappingURL=ProjectListProjectItem.js.map